export class ProfileCountry {
  public isoCode: string;
  public label: string;
  public phoneCode: string;
}